(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('.announcement-bar__message'));
      this.index = 0;
      this.onBlockSelect = (event) => {
        const selected = this.messages.indexOf(event.target);
        if (selected === -1) return;
        this.stop();
        this.show(selected);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      if (this.messages.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.show((this.index + 1) % this.messages.length), 5000);
    }

    stop() {
      clearInterval(this.timer);
    }

    show(index) {
      this.messages[this.index].classList.remove('is-active');
      this.index = index;
      this.messages[this.index].classList.add('is-active');
    }
  }

  if (!customElements.get('announcement-rotator')) {
    customElements.define('announcement-rotator', AnnouncementRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-manifesto"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pet-supply-finder')) {
    customElements.define('pet-supply-finder', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-pet-finder]');
        this.steps = [...this.querySelectorAll('[data-finder-step]')];
        this.progress = [...this.querySelectorAll('[data-finder-progress]')];
        this.querySelector('[data-pet-finder-open]')?.addEventListener('click', () => this.open());
        this.querySelector('[data-pet-finder-close]')?.addEventListener('click', () => this.dialog.close());
        this.querySelectorAll('[data-finder-pet]').forEach((button) => button.addEventListener('click', () => { this.pet = button.dataset.finderPet; this.show('moment'); }));
        this.querySelectorAll('[data-finder-moment]').forEach((button) => button.addEventListener('click', () => this.showResult(button.dataset.finderMoment)));
        this.querySelectorAll('[data-finder-back]').forEach((button) => button.addEventListener('click', () => this.show(button.dataset.finderBack)));
        this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
      }
      open() { this.pet = null; this.show('pet'); this.dialog.showModal(); }
      show(name) {
        const order = ['pet', 'moment', 'result'];
        const activeIndex = order.indexOf(name);
        this.steps.forEach((step) => { const active = step.dataset.finderStep === name; step.hidden = !active; if (active) requestAnimationFrame(() => step.querySelector('h3')?.focus()); });
        this.progress.forEach((item, index) => { item.classList.toggle('is-active', index === activeIndex); item.classList.toggle('is-complete', index < activeIndex); });
      }
      showResult(moment) {
        const destination = this.querySelector(`[data-finder-destination][data-pet="${this.pet}"][data-moment="${moment}"]`);
        const link = this.querySelector('[data-finder-result-link]');
        const text = this.querySelector('[data-finder-result-text]');
        if (destination && link && text) { link.href = destination.dataset.url; text.textContent = destination.dataset.summary; }
        this.show('result');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.onSubmit = this.onSubmit.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);

      document.addEventListener('submit', this.onSubmit);
      document.addEventListener('click', this.onClick);
      document.addEventListener('change', this.onChange);

      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog?.addEventListener('close', () => {
        const error = this.querySelector('[data-cart-error]');
        if (error) error.hidden = true;
      });
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.onSubmit);
      document.removeEventListener('click', this.onClick);
      document.removeEventListener('change', this.onChange);
    }

    get isDrawer() {
      return this.dataset.cartType === 'drawer';
    }

    open() {
      if (this.dialog && !this.dialog.open) this.dialog.showModal();
    }

    close() {
      this.dialog?.close();
    }

    onClick(event) {
      if (event.target.closest('[data-cart-drawer-close]')) {
        this.close();
        return;
      }

      const toggle = event.target.closest('[data-cart-drawer-toggle]');
      if (toggle) {
        if (!this.isDrawer || event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        this.open();
        return;
      }

      const step = event.target.closest('[data-cart-step]');
      if (step) {
        const line = step.closest('[data-cart-line]');
        const input = line?.querySelector('[data-cart-quantity]');
        if (!line || !input) return;
        const quantity = Math.max(0, (Number(input.value) || 0) + Number(step.dataset.cartStep));
        this.change(Number(line.dataset.cartLine), quantity, step);
        return;
      }

      const remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        this.change(Number(remove.closest('[data-cart-line]').dataset.cartLine), 0, remove);
      }
    }

    onChange(event) {
      const input = event.target.closest?.('[data-cart-quantity]');
      if (!input) return;
      const line = Number(input.closest('[data-cart-line]').dataset.cartLine);
      this.change(line, Math.max(0, Number(input.value) || 0), input);
    }

    async onSubmit(event) {
      const form = event.target;
      if (event.defaultPrevented || !this.isDrawer || !(form instanceof HTMLFormElement)) return;
      const action = new URL(form.getAttribute('action') || '', window.location.href);
      if (!action.pathname.endsWith('/cart/add')) return;

      event.preventDefault();
      const submitter = event.submitter ?? form.querySelector('[type="submit"]');
      submitter?.setAttribute('aria-busy', 'true');

      const body = new FormData(form);
      body.append('sections', this.sectionIds().join(','));
      body.append('sections_url', window.location.pathname);

      try {
        const response = await fetch(`${this.dataset.addUrl}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        });
        const data = await response.json();
        if (response.ok) {
          this.renderSections(data.sections);
        } else {
          this.showError(data.description || data.message);
        }
        this.open();
      } catch (error) {
        form.submit();
      } finally {
        submitter?.removeAttribute('aria-busy');
      }
    }

    sectionIds() {
      const ids = [this.dataset.sectionId];
      const page = document.querySelector('[data-cart-page]');
      if (page) ids.push(page.dataset.sectionId);
      return ids;
    }

    async change(line, quantity, trigger) {
      const page = document.querySelector('[data-cart-page]');
      const focusKey = this.focusKey(trigger);
      this.setBusy(true, page);

      try {
        const response = await fetch(`${this.dataset.changeUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line,
            quantity,
            sections: this.sectionIds(),
            sections_url: window.location.pathname,
          }),
        });
        const data = await response.json();
        if (!response.ok) {
          this.showError(data.description || data.message);
          return;
        }
        this.renderSections(data.sections);
        this.restoreFocus(focusKey);
      } catch (error) {
        window.location.href = this.dataset.cartUrl;
      } finally {
        this.setBusy(false, page);
      }
    }

    setBusy(busy, page) {
      [this, page].forEach((element) => {
        if (!element) return;
        if (busy) {
          element.setAttribute('aria-busy', 'true');
        } else {
          element.removeAttribute('aria-busy');
        }
      });
    }

    focusKey(trigger) {
      const line = trigger?.closest('[data-cart-line]');
      if (!line) return null;
      const selector = trigger.matches('[data-cart-step]')
        ? `[data-cart-step="${trigger.dataset.cartStep}"]`
        : '[data-cart-quantity]';
      return { line: line.dataset.cartLine, selector, onPage: Boolean(trigger.closest('[data-cart-page]')) };
    }

    restoreFocus(key) {
      if (!key) return;
      const root = key.onPage ? document.querySelector('[data-cart-page]') : this;
      const target =
        root?.querySelector(`[data-cart-line="${key.line}"] ${key.selector}`) ??
        root?.querySelector('[data-cart-quantity]') ??
        (key.onPage ? root?.querySelector('a, button') : this.querySelector('[data-cart-drawer-close]'));
      target?.focus();
    }

    renderSections(sections = {}) {
      Object.entries(sections).forEach(([id, html]) => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');

        if (id === this.dataset.sectionId) {
          const fresh = doc.querySelector('cart-drawer');
          const content = fresh?.querySelector('[data-cart-drawer-content]');
          const current = this.querySelector('[data-cart-drawer-content]');
          if (content && current) {
            const scrollTop = this.querySelector('[data-cart-drawer-body]')?.scrollTop ?? 0;
            current.innerHTML = content.innerHTML;
            const body = this.querySelector('[data-cart-drawer-body]');
            if (body) body.scrollTop = scrollTop;
          }
          if (fresh) {
            this.dataset.cartCount = fresh.dataset.cartCount;
            this.dataset.cartLabel = fresh.dataset.cartLabel;
          }
        } else {
          const fresh = doc.querySelector('[data-cart-page]');
          const current = document.querySelector(`[data-cart-page][data-section-id="${id}"]`);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }
      });

      this.updateCartCount();
    }

    updateCartCount() {
      const count = Number(this.dataset.cartCount) || 0;
      document.querySelectorAll('[data-cart-drawer-toggle]').forEach((link) => {
        link.setAttribute('aria-label', this.dataset.cartLabel);
        let badge = link.querySelector('.header__cart-count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'header__cart-count';
            badge.setAttribute('aria-hidden', 'true');
            link.append(badge);
          }
          badge.textContent = count;
        } else {
          badge?.remove();
        }
      });
    }

    showError(message) {
      if (!message) return;
      document.querySelectorAll('[data-cart-error]').forEach((error) => {
        error.textContent = message;
        error.hidden = false;
      });
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["depth-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('depth-carousel')) {
    customElements.define('depth-carousel', class extends HTMLElement {
      connectedCallback() {
        this.cards = [...this.querySelectorAll('[data-depth-card]')];
        this.dots = [...this.querySelectorAll('[data-depth-dot]')];
        this.index = 0;
        this.dragStart = null;
        this.dragDistance = 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion && !Shopify.designMode;
        this.delay = Math.max(Number(this.dataset.delay || 4200), 2200);
        this.layout();
        if (this.cards.length < 2) return;

        this.querySelector('[data-depth-prev]')?.addEventListener('click', () => this.show(this.index - 1, true));
        this.querySelector('[data-depth-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.depthDot), true)));
        this.cards.forEach((card) => card.addEventListener('click', (event) => {
          const target = Number(card.dataset.index);
          if (target !== this.index) { event.preventDefault(); this.show(target, true); }
        }));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index - 1, true); }
          if (event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + 1, true); }
        });
        this.addEventListener('pointerdown', (event) => {
          this.dragStart = event.clientX;
          this.dragDistance = 0;
        });
        this.addEventListener('pointermove', (event) => {
          if (this.dragStart === null) return;
          this.dragDistance = event.clientX - this.dragStart;
        });
        this.addEventListener('pointerup', () => this.finishDrag());
        this.addEventListener('pointercancel', () => this.finishDrag());
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.start(); });
        this.visibilityHandler = () => document.hidden ? this.stop() : this.start();
        document.addEventListener('visibilitychange', this.visibilityHandler);
        this.blockHandler = (event) => {
          const card = event.target.closest('[data-depth-card]');
          if (card) this.show(Number(card.dataset.index));
        };
        this.addEventListener('shopify:block:select', this.blockHandler);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.visibilityHandler);
      }

      finishDrag() {
        if (Math.abs(this.dragDistance) > 42) this.show(this.index + (this.dragDistance < 0 ? 1 : -1), true);
        this.dragStart = null;
        this.dragDistance = 0;
      }

      show(next, restart = false) {
        this.index = (next + this.cards.length) % this.cards.length;
        this.layout();
        if (restart) { this.stop(); this.start(); }
      }

      layout() {
        const count = this.cards.length;
        this.cards.forEach((card, cardIndex) => {
          let distance = cardIndex - this.index;
          if (count > 1) {
            distance = ((distance % count) + count) % count;
            if (distance > count / 2) distance -= count;
          }
          const behind = distance >= 0 ? distance : count + distance;
          const visible = behind <= 3;
          const active = behind === 0;
          const mobile = window.matchMedia('(max-width: 559px)').matches;
          const spread = mobile ? 34 : 68;
          card.style.setProperty('--depth-x', `${behind * spread}px`);
          card.style.setProperty('--depth-z', `${behind * -165}px`);
          card.style.setProperty('--depth-r', `${Math.min(behind, 1) * 17}deg`);
          card.style.setProperty('--depth-scale', String(1 - Math.min(behind, 3) * .035));
          card.style.setProperty('--depth-opacity', visible ? '1' : '0');
          card.style.setProperty('--depth-brightness', String(Math.max(.56, 1 - behind * .13)));
          card.style.setProperty('--depth-blur', `${Math.min(behind * 1.1, 3)}px`);
          card.style.setProperty('--depth-tint', String(Math.min(behind * .13, .42)));
          card.style.zIndex = String(100 - behind);
          card.classList.toggle('is-active', active);
          card.classList.toggle('is-clickable', visible);
          card.setAttribute('aria-hidden', String(!active));
          card.querySelectorAll('a, button').forEach((element) => active ? element.removeAttribute('tabindex') : element.setAttribute('tabindex', '-1'));
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
      }

      start() {
        if (!this.autoplay || this.timer || document.hidden || this.cards.length < 2) return;
        this.timer = window.setInterval(() => this.show(this.index + 1), this.delay);
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', (event) => {
    if (event.target instanceof HTMLDetailsElement && event.target.classList.contains('faq__item')) {
      event.target.open = true;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.onToggle = this.onToggle.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.addEventListener('toggle', this.onToggle, true);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    onToggle(event) {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;

      this.querySelectorAll('details[open]').forEach((other) => {
        if (other !== details && !other.contains(details)) other.open = false;
      });

      if (details.classList.contains('header__drawer')) {
        const headerBottom = this.closest('.header').getBoundingClientRect().bottom;
        this.style.setProperty('--header-bottom', `${headerBottom}px`);
      }

      if (details.classList.contains('header__search')) {
        details.querySelector('input[type="search"]')?.focus();
      }
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      const details = event.target.closest('details[open]');
      if (!details) return;
      details.open = false;
      details.querySelector('summary')?.focus();
    }

    onDocumentClick(event) {
      if (this.contains(event.target)) return;
      this.querySelectorAll('details[open]').forEach((details) => {
        details.open = false;
      });
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-hero')) {
    customElements.define('featured-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-hero-slide]')];
        this.dots = [...this.querySelectorAll('[data-hero-dot]')];
        if (this.slides.length < 2) return;
        this.index = 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.paused = this.reducedMotion || Shopify.designMode;
        this.delay = Number(this.dataset.autoplaySeconds || 7) * 1000;
        this.pauseButton = this.querySelector('[data-hero-pause]');
        this.previousHandler = () => this.show(this.index - 1, true);
        this.nextHandler = () => this.show(this.index + 1, true);
        this.querySelector('[data-hero-previous]')?.addEventListener('click', this.previousHandler);
        this.querySelector('[data-hero-next]')?.addEventListener('click', this.nextHandler);
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.heroDot), true)));
        this.pauseButton?.addEventListener('click', () => this.togglePause());
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.start(); });
        this.visibilityHandler = () => document.hidden ? this.stop() : this.start();
        document.addEventListener('visibilitychange', this.visibilityHandler);
        this.addEventListener('keydown', (event) => { if (event.key === 'ArrowLeft') this.show(this.index - 1, true); if (event.key === 'ArrowRight') this.show(this.index + 1, true); });
        this.blockSelectHandler = (event) => { const slide = event.target.closest('[data-hero-slide]'); if (slide) { this.paused = true; this.show(Number(slide.dataset.slideIndex)); this.updatePauseLabel(); } };
        this.addEventListener('shopify:block:select', this.blockSelectHandler);
        this.updatePauseLabel();
        this.start();
      }
      disconnectedCallback() { this.stop(); document.removeEventListener('visibilitychange', this.visibilityHandler); }
      show(nextIndex, restart = false) {
        const next = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === next;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.toggleAttribute('inert', !active);
          slide.querySelectorAll('a, button, input, select, textarea').forEach((element) => active ? element.removeAttribute('tabindex') : element.setAttribute('tabindex', '-1'));
        });
        this.dots.forEach((dot, index) => { dot.classList.toggle('is-active', index === next); if (index === next) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        this.index = next;
        if (restart) { this.stop(); this.start(); }
      }
      start() { if (this.paused || this.timer || document.hidden) return; this.timer = window.setInterval(() => this.show(this.index + 1), this.delay); }
      stop() { window.clearInterval(this.timer); this.timer = null; }
      togglePause() { if (this.reducedMotion) return; this.paused = !this.paused; this.paused ? this.stop() : this.start(); this.updatePauseLabel(); }
      updatePauseLabel() { if (!this.pauseButton) return; const text = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel; this.pauseButton.textContent = text; this.pauseButton.setAttribute('aria-label', text); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-hero-slide]')];
        this.dots = [...this.querySelectorAll('[data-hero-dot]')];
        this.toggle = this.querySelector('[data-hero-toggle]');
        this.toggleIcon = this.querySelector('[data-hero-toggle-icon]');
        this.status = this.querySelector('[data-hero-status]');
        this.index = Math.max(this.slides.findIndex((slide) => slide.classList.contains('is-active')), 0);
        this.pointerStart = null;
        this.pointerDistance = 0;
        this.suppressClick = false;
        this.userPaused = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion && !Shopify.designMode;
        this.delay = Math.max(Number(this.dataset.delay || 6000), 3000);
        if (this.slides.length < 2) return;

        this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.show(this.index - 1, true));
        this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.heroDot), true)));
        this.toggle?.addEventListener('click', () => this.toggleAutoplay());
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index - 1, true); }
          if (event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + 1, true); }
        });
        this.addEventListener('pointerdown', (event) => { this.pointerStart = event.clientX; this.pointerDistance = 0; });
        this.addEventListener('pointermove', (event) => { if (this.pointerStart !== null) this.pointerDistance = event.clientX - this.pointerStart; });
        this.addEventListener('pointerup', () => this.finishSwipe());
        this.addEventListener('pointercancel', () => this.finishSwipe());
        this.addEventListener('click', (event) => {
          if (!this.suppressClick) return;
          event.preventDefault();
          this.suppressClick = false;
        }, true);
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.start(); });
        this.visibilityHandler = () => document.hidden ? this.stop() : this.start();
        document.addEventListener('visibilitychange', this.visibilityHandler);
        this.blockHandler = (event) => {
          const slide = event.target.closest('[data-hero-slide]');
          if (slide) this.show(Number(slide.dataset.index));
        };
        this.addEventListener('shopify:block:select', this.blockHandler);
        if (!this.autoplay && this.toggle) this.toggle.hidden = true;
        this.start();
      }

      disconnectedCallback() { this.stop(); document.removeEventListener('visibilitychange', this.visibilityHandler); }

      finishSwipe() {
        if (Math.abs(this.pointerDistance) > 45) {
          this.suppressClick = true;
          this.show(this.index + (this.pointerDistance < 0 ? 1 : -1), true);
        }
        this.pointerStart = null;
        this.pointerDistance = 0;
      }

      show(next, restart = false) {
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          const link = slide.querySelector('a');
          if (link) link.tabIndex = active ? 0 : -1;
        });
        this.dots.forEach((dot, index) => {
          const active = index === this.index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (this.status) this.status.textContent = `${this.index + 1} of ${this.slides.length}`;
        if (restart) { this.stop(); this.start(); }
      }

      toggleAutoplay() {
        this.userPaused = !this.userPaused;
        if (this.userPaused) this.stop(); else this.start();
        if (this.toggle) this.toggle.setAttribute('aria-label', this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
        if (this.toggleIcon) this.toggleIcon.textContent = this.userPaused ? '▶' : 'Ⅱ';
      }

      start() {
        if (!this.autoplay || this.userPaused || this.timer || document.hidden) return;
        this.timer = window.setInterval(() => this.show(this.index + 1), this.delay);
      }

      stop() { window.clearInterval(this.timer); this.timer = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joy-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('routine-finder')) {
    customElements.define('routine-finder', class extends HTMLElement {
      connectedCallback() {
        this.buttons = [...this.querySelectorAll('[data-routine-filter]')];
        this.cards = [...this.querySelectorAll('[data-routine-card]')];
        this.buttons.forEach((button) => button.addEventListener('click', () => this.filter(button)));
      }

      filter(activeButton) {
        const filter = activeButton.dataset.routineFilter;
        this.buttons.forEach((button) => {
          const active = button === activeButton;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        this.cards.forEach((card) => {
          card.hidden = filter !== 'all' && card.dataset.pet !== 'all' && card.dataset.pet !== filter;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('script[data-product-json]');
      if (!data) return;

      this.product = JSON.parse(data.textContent);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.addEventListener('change', (event) => {
        if (event.target.classList.contains('variant-picker__input')) this.onOptionChange();
      });

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quantity-step]');
        if (button) this.stepQuantity(Number(button.dataset.quantityStep));
      });

      this.setUpGalleryCounter();
    }

    get fieldsets() {
      return Array.from(this.querySelectorAll('.variant-picker__option'));
    }

    onOptionChange() {
      const selected = this.fieldsets.map((fieldset) => fieldset.querySelector('input:checked')?.value);
      const variant = this.product.variants.find((item) =>
        item.options.every((value, index) => value === selected[index])
      );

      this.fieldsets.forEach((fieldset, index) => {
        const label = fieldset.querySelector('[data-option-selected]');
        if (label) label.textContent = selected[index] ?? '';

        fieldset.querySelectorAll('.variant-picker__input').forEach((input) => {
          const candidate = [...selected];
          candidate[index] = input.value;
          const available = this.product.variants.some(
            (item) => item.available && item.options.every((value, position) => value === candidate[position])
          );
          input.toggleAttribute('data-unavailable', !available);
        });
      });

      this.renderVariant(variant);
    }

    renderVariant(variant) {
      const button = this.querySelector('[data-add-to-cart]');

      if (!variant) {
        if (button) {
          button.disabled = true;
          button.textContent = this.product.strings.unavailable;
        }
        return;
      }

      const idInput = this.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;

      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? this.product.strings.addToCart : this.product.strings.soldOut;
      }

      const onSale = Boolean(variant.compareAtPrice);
      const current = this.querySelector('[data-price-current]');
      const compare = this.querySelector('[data-price-compare]');
      if (current) current.textContent = variant.price;
      if (compare && onSale) compare.textContent = variant.compareAtPrice;
      this.querySelector('[data-price-compare-wrapper]')?.toggleAttribute('hidden', !onSale);
      this.querySelector('[data-price-sale-label]')?.toggleAttribute('hidden', !onSale);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (variant.mediaId) this.showMedia(variant.mediaId);
    }

    showMedia(mediaId) {
      const item = this.querySelector(`[data-media-id="${mediaId}"]`);
      const list = item?.parentElement;
      if (!item || !list) return;

      if (list.scrollWidth > list.clientWidth) {
        list.scrollTo({
          left: item.offsetLeft - list.offsetLeft,
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
        });
      } else {
        list.prepend(item);
      }
    }

    stepQuantity(step) {
      const input = this.querySelector('input[name="quantity"]');
      if (!input) return;
      const min = Number(input.min) || 1;
      input.value = Math.max(min, (Number(input.value) || min) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    setUpGalleryCounter() {
      const list = this.querySelector('.product-gallery__list');
      const counter = this.querySelector('[data-gallery-index]');
      if (!list || !counter) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) counter.textContent = Array.from(list.children).indexOf(entry.target) + 1;
          });
        },
        { root: list, threshold: 0.6 }
      );
      Array.from(list.children).forEach((item) => observer.observe(item));
    }
  }

  if (!customElements.get('product-info')) {
    customElements.define('product-info', ProductInfo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = html.querySelector('product-recommendations');
        if (fresh && fresh.innerHTML.trim().length) this.innerHTML = fresh.innerHTML;
      } catch (error) {
        console.error(error);
      }
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-showcase')) {
    customElements.define('product-showcase', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-showcase-track]');
        this.slides = [...this.querySelectorAll('[data-showcase-slide]')];
        if (!this.track || this.slides.length < 2) return;
        this.current = this.querySelector('[data-showcase-current]');
        this.querySelector('[data-showcase-previous]')?.addEventListener('click', () => this.move(-1));
        this.querySelector('[data-showcase-next]')?.addEventListener('click', () => this.move(1));
        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.move(-1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); this.move(1); }
        });
        this.track.addEventListener('scroll', () => {
          window.clearTimeout(this.scrollTimer);
          this.scrollTimer = window.setTimeout(() => this.updateStatus(), 80);
        }, { passive: true });
      }
      move(direction) {
        const index = this.index();
        const next = Math.min(Math.max(index + direction, 0), this.slides.length - 1);
        this.track.scrollTo({
          left: this.slides[next].offsetLeft - this.track.offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        if (this.current) this.current.textContent = next + 1;
      }
      index() {
        const left = this.track.getBoundingClientRect().left;
        let closest = 0;
        this.slides.forEach((slide, index) => {
          if (Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(this.slides[closest].getBoundingClientRect().left - left)) closest = index;
        });
        return closest;
      }
      updateStatus() { if (this.current) this.current.textContent = this.index() + 1; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
